import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLocale } from "@/middleware";
import { useTranslate } from "@/locales";
import { routes } from "@/consts";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";

function NotFoundPage() {
  const navigate = useNavigate();
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ textAlign: "center", width: "100%" }}>
        <SentimentVeryDissatisfiedIcon
          sx={{ fontSize: 80, color: "warning.main", mb: 2 }}
        />
        <Typography variant="h2" fontWeight={700} sx={{ mb: 2 }}>
          404
        </Typography>
        <Typography variant="h5" sx={{ mb: 1 }}>
          {t("notFound.title")}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          {t("notFound.body")}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => navigate(routes.home)}
          sx={{ borderRadius: 2, px: 4, py: 1.5, fontWeight: 600 }}
        >
          {t("actions.backToHome")}
        </Button>
      </Box>
    </Container>
  );
}

export default NotFoundPage;
